import { describeNonError, nonErrorText } from "../../engine/shared/nonError"

// Bugsnag groups every promise rejected with a non-Error under one
// « InvalidError … non-error » per build; name the event after the rejected value.

// The tab is named after the component that caught the rejection: the React
// Native plugin on the app, the browser's unhandledrejection handler on the web.
const REJECTION_TABS = [
    "promise rejection tracking",
    "unhandledrejection handler",
]

const NOT_FOUND = Symbol("no rejected value")

const rejectedValue = (event) => {
    for (const tab of REJECTION_TABS) {
        const value = event.getMetadata?.(tab, "non-error parameter")
        if (value === undefined) continue
        // Bugsnag keeps a rejected null or undefined as the string "null" or "undefined".
        if (value === "null") return null
        return value === "undefined" ? undefined : value
    }
    return NOT_FOUND
}

// Bugsnag `onError` callback: never drops the event, only names it.
export const nameNonErrorRejection = (event) => {
    const error = event?.errors?.[0]
    if (error?.errorClass !== "InvalidError") return true

    const value = rejectedValue(event)
    if (value === NOT_FOUND) return true

    const description = describeNonError(value)
    error.errorClass = "NonErrorRejection"
    error.errorMessage = nonErrorText(description)
    event.groupingHash = `non-error-rejection:${description.kind}`
    return true
}
